import type { Referral } from "@/src/models/documents/referral";
import { getPersonName } from "@/src/models/person";

export const ENTS_TEL_ENC_REASON = "Referral";

export function buildEntsTelEncMessage(referral: Pick<Referral, "receivingProvider" | "reasonForReferral">): string {
  const providerName = referral.receivingProvider?.familyName?.trim()
    ? getPersonName(referral.receivingProvider)
    : "ENT";

  return `Please schedule this patient. Referred to ${providerName} for ${referral.reasonForReferral || "diagnosis"}.`;
}
